//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      constant,
      localSearchString: '',
      filters: {
        searchString: '',
        dateCreatedFrom: '',
        dateCreatedTo: '',
      },
    };
  },

  computed: {
    ...mapState('adminManagementAdmins', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.filters = {
        ...this.filters,
        searchString: id,
      };
      this.localSearchString = id;
      this.setFilters(this.filters);
      this.$router.replace({ query: {} });
      window.scrollTo(0, document.body.scrollHeight);
    } else {
      this.setFilters({});
    }
  },

  methods: {
    ...mapActions('adminManagementAdmins', ['setFilters']),

    filterAction(action) {
      this.$emit('filterAction', action);
    },

    handleSearchBlur() {
      this.filters.searchString = this.localSearchString;
    },
  },
};
